import React, { Component } from 'react';
import { FHETable } from 'data/components';
import { withRouter } from 'react-router-dom';
import Translator from 'translator';
import PropTypes from 'prop-types';
import { Toastr } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { Add as AddIcon, Refresh as RefreshIcon, RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { connect } from 'react-redux';
import { getAllPushNotifications } from '../../data/PushNotifications/actions';
import tools from "../../../../data/common/tools";

class PushNotification extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            pushNotifications: {},
            loading: true
        };
    }

    componentDidMount() {
        this.refreshPushNotification();
    }

    refreshPushNotification = () => {
        const { loading } = this.state;
        const { history } = this.props;
        if (!loading) this.setState({ loading: true });
        return getAllPushNotifications(history.environment)
            .then(pushNotifications => {
                this.setState({
                    pushNotifications,
                    loading: false
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({ loading: false });
            });
    };

    navigateToAdd = () => {
        const { history } = this.props;
        return history.push({ pathname: `push-notifications/add` });
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `push-notifications/detail/${rowData.id}` });
    };

    renderData = () => {
        const { pushNotifications } = this.state;
        const { history } = this.props;

        let results = [];

        Object.keys(pushNotifications).map(key => {
            const pushNotification = pushNotifications[key];

            results.push({
                id: parseInt(key),
                body: pushNotification.body.length > 110 ? pushNotification.body.slice(0, 110).concat('...') : pushNotification.body,
                title: pushNotification.title,
                status: pushNotification.date
                    ? Translator.translate(`generic.pushNotification.status.sent`)
                    : Translator.translate(`generic.pushNotification.status.draft`),
                date: pushNotification.date,
                recipient: Translator.translate(`generic.pushNotification.recipient.${pushNotification.recipient}`)
            });
        });

        return results;
    };

    renderActions = () => {
        const { profile, history } = this.props;
        let actions = {
            row: [],
            toolbar: [
                {
                    icon: RefreshIcon,
                    tooltip: Translator.translate(`generic.pushNotification.table.globalAction.refresh.tooltip`),
                    onClick: this.refreshPushNotification
                }
            ]
        };
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('pushNotificationAdd')) {
            actions.toolbar.push({
                icon: AddIcon,
                tooltip: Translator.translate(`generic.pushNotification.table.globalAction.add.tooltip`),
                onClick: this.navigateToAdd
            });
        }
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('pushNotificationDetails')) {
            actions.row.push({
                icon: ViewIcon,
                tooltip: Translator.translate(`general.showDetail`),
                onClick: this.navigateToDetail
            });
        }
        return actions;
    };

    renderColumns = () => {
        return [
            {
                title: Translator.translate('general.table.column.id'),
                name: 'id',
                fixedLeft: true,
                width: 90
            },
            {
                title: Translator.translate('general.table.column.title'),
                name: 'title',
                width: 250
            },
            {
                title: Translator.translate('general.table.column.body'),
                name: 'body'
            },
            {
                title: Translator.translate('general.table.column.status'),
                name: 'status',
                width: 120
            },
            {
                title: Translator.translate('general.table.column.sentDate'),
                name: 'date',
                customSort: tools.sortDate,
                width: 180
            },
            {
                title: Translator.translate('general.table.column.recipient'),
                name: 'recipient',
                width: 200
            }
        ];
    };

    render() {
        const { loading } = this.state;
        const { history } = this.props;
        return (
            <FHETable
                idTable="pushNotificationList"
                columns={this.renderColumns()}
                data={this.renderData()}
                actions={this.renderActions()}
                title={Translator.translate(`generic.pushNotification.table.title`)}
                emptyDataSourceMessage={Translator.translate(`generic.pushNotification.table.body.emptyDataSourceMessage`)}
                isLoading={loading}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        profile: state.data.user
    };
}

export default withRouter(renderEnvComponent('scenes/PushNotification/index', connect(mapStateToProps)(PushNotification)));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/PushNotification/index.js